import * as angular from "angular";
import {ActionReasonModel} from "../models/action-reason.model";
import {ActionReasonVisibilityEnum} from "../enums/action-reason-visibility.enum";
import {ActionReasonEntityEnum} from "../enums/action-reason-entity.enum";
import {ActionReasonEnum} from "../enums/action-reason.enum";
import {TaskStatusType} from "../../tasks/types/taskStatus.type";

export class ActionReasonsRequestsService {

  constructor(private ActionReasonsAPI, private $actionReasons) {
  }

  getActionReasons(
    visibility?: ActionReasonVisibilityEnum[],
    entityTypes?: ActionReasonEntityEnum[],
    reasonTypes?: ActionReasonEnum[],
    pickupStatuses?: TaskStatusType[],
    dropoffStatuses?: TaskStatusType[],
    operationStatuses?: TaskStatusType[]
  ) {
    const api = this.ActionReasonsAPI.actions.getAll;
    return this.$$call(api, {
      visibility: visibility,
      entityType: entityTypes,
      reasonType: reasonTypes,
      pickupStatuses: pickupStatuses,
      dropoffStatuses: dropoffStatuses,
      operationStatuses: operationStatuses
    }, {}, {});
  }

  createActionReason(actionReason: ActionReasonModel) {
    const api = this.ActionReasonsAPI.actions.createActionReason;
    return this.$$call(api, {}, actionReason, {});
  }

  updateActionReason(updatedActionReason: ActionReasonModel) {
    const api = this.ActionReasonsAPI.actions.updateActionReason;
    return this.$$call(api, {}, updatedActionReason, {id: updatedActionReason.id});
  }

  deleteActionReason(actionReasonId: string) {
    const api = this.ActionReasonsAPI.actions.deleteActionReason;
    return this.$$call(api, {}, {}, {id: actionReasonId});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$actionReasons().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.action-reasons')
  .service('actionReasonsRequestsService', ActionReasonsRequestsService);
